var  tmp_fsb64 = "eyJleHBpcnkiOjE2MzEyODg4MzIuNTczOTE1Mn0="; 
var tmp_fsh = "1395de03c440ded3c340db92ebbaa395bb899c1fdc1d4ecb4f01cf411c396f16";
var cUrlSigInline = "security=policy:" + tmp_fsb64 + ",signature:" + tmp_fsh;

function fixSrcFilestack(src) {
    src = formsReplaceOldRoot(src);
    if (src.toLowerCase().indexOf("cdn.filestack") != -1) {
        var ix = src.indexOf("?");
        if (ix != -1) {
            src = src.substring(0, ix);
        }
        return spliceStr(src, src.lastIndexOf("/"), 0, "/" + cUrlSigInline);
    }
    return src;
}
function formsReplaceOldRoot(s){
    if(!s || !s.replace) return s;
    return s.replace("doimage.workers.dev", "youniq.co.uk");
}

spliceStr = function (me, idx, rem, str) {
    return me.slice(0, idx) + str + me.slice(idx + Math.abs(rem));
};

function getCustUrl(){
 var cart = $(".cart-item-data").text()
 var cstData = atob(cart.split(":")[1].trim());
 var csjson  = JSON.parse(cstData);
 var src= csjson.find(a=>a.id=="preview").val;
 return fixSrcFilestack(src);
}
